module.exports = __webpack_public_path__ + "static/CircularPro-Medium.6d9ac4df.woff2";


//////////////////
// WEBPACK FOOTER
// ./public/fonts/CircularPro-Medium.woff2
// module id = 732
// module chunks = 168707334958949